import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TextInput from '../../../../../common/Form/Fields/TextInput';
import Loading from '../../../../../common/base/Loading';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
const EmailModal: React.FC<{
  email: string;
  mutate: (email: string) => void;
}> = t0 => {
  const $ = _c(14);
  const {
    email,
    mutate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] !== history) {
    t1 = () => history.push({
      pathname: "/settings/organization/billing",
      state: {
        scroll: false
      }
    });
    $[0] = history;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClose = t1;
  let t2;
  if ($[2] !== HookdeckAPI.billing || $[3] !== addToast || $[4] !== mutate || $[5] !== onClose) {
    t2 = v => {
      HookdeckAPI.billing.updateBillingEmail(v.email).then(t3 => {
        const {
          email: email_0
        } = t3;
        addToast("success", "Billing email mail updated");
        mutate(email_0);
        onClose();
      }).catch(() => {
        addToast("error", "Failed to update billing email, please contact us.");
      });
    };
    $[2] = HookdeckAPI.billing;
    $[3] = addToast;
    $[4] = mutate;
    $[5] = onClose;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onSubmit = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== email || $[9] !== onClose) {
    t4 = props => <form onSubmit={props.handleSubmit}><Modal title="Update billing email" cancel_label="Cancel" submit_label="Confirm" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose}>{!email ? <Loading /> : <TextInput name="email" type="email" label="Billing email" required={true} placeholder={email} m={{
          b: 0
        }} />}</Modal></form>;
    $[8] = email;
    $[9] = onClose;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onSubmit || $[12] !== t4) {
    t5 = <Formik initialValues={t3} onSubmit={onSubmit}>{t4}</Formik>;
    $[11] = onSubmit;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default EmailModal;